import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, FileBadgeIcon, PawPrintIcon, SmartphoneIcon, TrashIcon, TriangleAlertIcon, VolleyballIcon } from 'lucide-react';
import { quickLinks } from '../data/homepage';
const icons = {
  smartphone: SmartphoneIcon,
  ball: VolleyballIcon,
  alert: TriangleAlertIcon,
  trash: TrashIcon,
  pet: PawPrintIcon,
  permit: FileBadgeIcon,
  bell: BellIcon
};
export function QuickAccess() {
  return <section aria-labelledby="quick-services" className="bg-ville-lime pb-4 pt-2" data-id="element-1810" data-mp="2e9ap7as18gix">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-1811" data-mp="2i9thf5xu7oln">
        <div className="rounded-[2rem] border-2 border-ville-navy bg-white px-6 py-7 shadow-[0_18px_45px_-18px_rgba(6,55,49,0.45)] lg:px-10" data-id="element-1812" data-mp="2n1cm4z2w7eog">
          <h2 id="quick-services" className="text-center font-display text-sm font-extrabold uppercase tracking-[0.18em] text-ville-blue" data-id="element-1813" data-mp="2s0fuase6610n">
            Online Services
          </h2>
          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-4 lg:grid-cols-7" data-id="element-1814" data-mp="3206n8pn307ym">
            {quickLinks.map(link => {
            const Icon = icons[link.icon as keyof typeof icons];
            return <li key={link.label} data-id="element-1815" data-mp="3vwdmocehe84n">
                  <Link to={link.to ?? '/'} className="group flex flex-col items-center gap-3 rounded-2xl px-2 py-1 text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1816" data-mp="3vzhvjn2w5s1n">
                    <span className="grid h-16 w-16 place-items-center rounded-full bg-ville-blue text-white transition-[transform,background-color,color] duration-150 ease-ville group-hover:-translate-y-1 group-hover:bg-ville-lime group-hover:text-ville-navy" data-id="element-1817" data-mp="3mytj2wt5bzqv">
                      <Icon className="h-7 w-7" aria-hidden="true" data-id="element-1818" data-mp="dpz8qdg7py69" />
                    </span>
                    <span className="text-sm font-bold leading-tight text-ville-navy" data-id="element-1819" data-mp="9p5llmalgnef">{link.label}</span>
                  </Link>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}